import { render, staticRenderFns } from "./DashboardOrdersWidget.vue?vue&type=template&id=9295cf6c&"
import script from "./DashboardOrdersWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardOrdersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports